import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Action} from '@ngrx/store';

import * as commonActions from '../actions/common.actions';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import {Actions, Effect} from '@ngrx/effects';
import {CommonService, AuthService} from '../../services/index';


@Injectable()
export class CommonEffects {

    @Effect()
    isAuth: Observable<Action> = this.actions$
        .ofType(commonActions.IS_AUTH) /* When [Contacts] LOAD ALL action is dispatched */
        //.map((action: commonActions.LoadAllItem) => action.payload)
        .startWith(new commonActions.IsAuth())
        .switchMap((params) =>
            this.authService.isauth(params) /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((auth: any[]) => new commonActions.IsAuthSuccess(auth))

        );


        @Effect()
    loadAllParty$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_PARTY) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllParty) => action.payload)
        //.startWith(new commonActions.LoadAllSku())
        .switchMap((params) =>
            this.commonService.loadPartyList(params) /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((partylist: any[]) => new commonActions.LoadAllPartySuccess(partylist))

        );

    @Effect()
    loadAllCompany$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_COMPANY) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllCompany) => action.payload)
        //.startWith(new commonActions.LoadAllSku())
        .switchMap((params) =>
            this.commonService.loadCompanyList(params) /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((partylist: any[]) => new commonActions.LoadAllCompanySuccess(partylist))

        );

    constructor(
        private actions$: Actions,
        private commonService: CommonService,
        private authService: AuthService
    ) { }


}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/store/effects/common.effects.ts